<template>
  <div class="pt-5">
    <List v-if="imagesSceleton || huiles.length > 0 || user" type="horizontalSwiper" title="Huiles" category="huiles" url="/huiles" :items="huiles"/>
    <List v-if="imagesSceleton || dessins.length > 0 || user" type="horizontalSwiper" title="Dessins" category="dessins" url="/dessins" :items="dessins"/>
    <List v-if="imagesSceleton || atelier.length > 0 || user" type="horizontalSwiper" title="Atelier" category="atelier" url="/atelier" :items="atelier"/>
    <List
      v-if="artists.length > 0 || user"
      type="artistsSwiper"
      title="Les artistes que je recommande"
      url="/artists"
      category="artists"
      :items="artists"
    />
  </div>
</template>

<script>
import List from "../components/List";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["huiles", "dessins", "atelier", "artists", "user", "imagesSceleton"])
  },
  components: {
    List
  },
  methods: {
  }
};
</script>